import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { getBaseUrl } from "../../../service/apiUrl";
import Accordion from "react-bootstrap/Accordion";
import Lottie from "lottie-react";
import Animate from "../../../assets/loader.json";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const LatestWinnersCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const cookiedata = Cookies.get("i18next");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWinners = async () => {
      try {
        const baseUrl = getBaseUrl();
        const response = await axios.get(`${baseUrl}/latest-winners?limit=5`);
        if (response.data && response.data.success) {
          setData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching latest races:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchWinners();
  }, []);

  const handleRaceClick = (raceId) => {
    if (raceId) navigate(`/race-detail?${raceId}`);
  };

  return (
    <div className="lrc-container">
      {/* Header Row */}
      <div className="lrc-header-row">
        <h2 className="lrc-title">{t("LATEST RACES")}</h2>
        {/* <span className="lrc-sort-badge">⬆ {t("Sort by Latest")}</span> */}
      </div>

      <Accordion defaultActiveKey="0">
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
            <Lottie animationData={Animate} loop={true} style={{ width: "80px" }} />
          </div>
        ) : data.length > 0 ? (
          data.map((item, index) => (
            <Accordion.Item
              eventKey={item.id || index.toString()}
              key={item.id || index}
              className="lrc-acc-item"
            >
              <Accordion.Header className="lrc-acc-header">
                <div className="lrc-acc-header-inner">
                  <div>
                    <h3 className="lrc-location">{cookiedata === "en" ? item.locationEn : item.locationAr}</h3>
                    <div className="lrc-date">{item.date}</div>
                  </div>
                  <i className="fa fa-chevron-down lrc-chevron" aria-hidden="true"></i>
                </div>
              </Accordion.Header>

              <Accordion.Body style={{ padding: "0" }}>
                <div className="lrc-body">
                  {item.races && item.races.length > 0 ? (
                    item.races.map((race) => (
                      <div
                        key={race.id}
                        className="lrc-race-row"
                        onClick={() => handleRaceClick(race.id)}
                        title="Click to view race detail"
                      >
                        {/* Race Number Tag */}
                        <div className="lrc-race-num-tag">
                          <span className="lrc-race-num-label">{t("Race")}</span>
                          <span className="lrc-race-num-val">{race.raceNumber}</span>
                        </div>

                        {/* Winner Horse Name — takes full width */}
                        <div className="lrc-race-center">
                          <span className="lrc-horse-name">
                            {cookiedata === "en" ? race.winnerHorseNameEn : race.winnerHorseNameAr}
                          </span>
                        </div>

                        {/* Time */}
                        <span className="lrc-time">{race.time}</span>

                        {/* Arrow */}
                        <span className="lrc-arrow">›</span>
                      </div>
                    ))
                  ) : (
                    <p style={{ textAlign: "center", color: "#999", padding: "15px" }}>{t("No races scheduled")}</p>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          ))
        ) : (
          <p style={{ textAlign: "center", color: "#bbb", padding: "20px" }}>{t("NoDataFound")}</p>
        )}
      </Accordion>

      <style>{`
        /* ---- Container ---- */
        .lrc-container {
          background: #0d133a;
          border-radius: 20px;
          padding: 20px;
          margin-bottom: 20px;
          font-family: 'Segoe UI', Roboto, sans-serif;
        }

        /* ---- Header Row ---- */
        .lrc-header-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 18px;
        }
        .lrc-title {
          font-size: 20px;
          font-weight: 800;
          color: #fff;
          text-transform: uppercase;
          margin: 0;
          letter-spacing: 0.5px;
        }
        .lrc-sort-badge {
          font-size: 11px;
          font-weight: 600;
          color: #0d133a;
          background: #68a34d;
          border-radius: 20px;
          padding: 4px 10px;
          white-space: nowrap;
        }

        /* ---- Accordion Item ---- */
        .lrc-acc-item {
          background: transparent !important;
          border: none !important;
          margin-bottom: 10px !important;
          overflow: hidden;
          border-radius: 12px;
        }
        .lrc-acc-header .accordion-button {
          background: rgba(255,255,255,0.07) !important;
          border: none !important;
          box-shadow: none !important;
          padding: 12px 16px !important;
          border-radius: 0 !important;
          color: #fff !important;
          overflow: hidden;
        }
        .lrc-acc-header .accordion-button:not(.collapsed) {
          background: rgba(255,255,255,0.12) !important;
          border-radius: 0 !important;
        }
        .lrc-acc-header .accordion-button::after {
          display: none !important;
        }
        .lrc-acc-header-inner {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
        }
        .lrc-location {
          font-size: 16px;
          font-weight: 700;
          margin: 0;
          color: #fff;
        }
        .lrc-date {
          font-size: 12px;
          color: rgba(255,255,255,0.65);
          margin-top: 2px;
        }
        .lrc-chevron {
          color: rgba(255,255,255,0.7);
          font-size: 13px;
          transition: transform 0.2s;
        }

        /* ---- Body ---- */
        .lrc-body {
          background: #fff;
          border-radius: 0 0 14px 14px;
          overflow: hidden;
          border-bottom: 3px solid #68a34d;
        }

        /* ---- Race Row ---- */
        .lrc-race-row {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 11px 14px;
          border-bottom: 1px solid #f0f0f0;
          cursor: pointer;
          transition: background 0.18s;
        }
        .lrc-race-row:last-child {
          border-bottom: none;
        }
        .lrc-race-row:hover {
          background: #f0f5ff;
        }

        /* Race Number Tag */
        .lrc-race-num-tag {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #19469D;
          border-radius: 8px;
          padding: 5px 10px;
          min-width: 46px;
          flex-shrink: 0;
        }
        .lrc-race-num-label {
          font-size: 9px;
          font-weight: 600;
          color: rgba(255,255,255,0.8);
          text-transform: uppercase;
          line-height: 1;
        }
        .lrc-race-num-val {
          font-size: 18px;
          font-weight: 800;
          color: #fff;
          line-height: 1.1;
        }

        /* Horse Name */
        .lrc-race-center {
          flex: 1;
          min-width: 0;
        }
        .lrc-horse-name {
          font-size: 14px;
          font-weight: 800;
          color: #19469D;
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        /* Time */
        .lrc-time {
          font-size: 12px;
          color: #666;
          flex-shrink: 0;
          white-space: nowrap;
        }

        /* Arrow */
        .lrc-arrow {
          font-size: 20px;
          color: #19469D;
          font-weight: 700;
          flex-shrink: 0;
          line-height: 1;
        }
      `}</style>
    </div>
  );
};

export default LatestWinnersCard;